import * as React from 'react';
import cx from 'classnames';
import {NavLink} from 'react-router-dom';
import style from './MobileMenu.css';

import IconMenu from './icons/menu.inline.svg';
import IconCancel from './icons/cancel.inline.svg';

import {Nav} from 'components/Nav';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

export const MobileMenu = (props) => (
    <div className={cx(style.root, props.className)}>
        <div className={style.icon}>
            <button
                className={cx(style.btnMenu)}
                onClick={props.onOpen}>
                <IconMenu className={cx(style.menu)}/>
            </button>
        </div>
    </div>
);

export class MobileNav extends React.Component {
    componentWillUnmount() {
        enableBodyScroll(this.node);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.show === nextProps.show) {
            return;
        }

        if (nextProps.show) {
            disableBodyScroll(this.node);
        } else {
            enableBodyScroll(this.node);
        }
    }

    render() {
        const {show, onClose} = this.props;
        return (
            <div ref={c => this.node = c} className={cx(style.nav, {[style.open]: show})}>
                <button
                    className={cx(style.btnClose)}
                    onClick={onClose}>
                    <IconCancel className={cx(style.cancel)}/>
                </button>
                <Nav onClick={onClose}/>
            </div>
        );
    }
}
